import functions from '../functions.js';
import Slider from "../components/Slider";
import { details } from './details';

$(() => {
    detailsTravel.init();
})

const detailsTravel = {
    $details: null,
    $form: null,
    form: null,
    params: {
        objectId: null, 
        unitId: null, 
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: null,
        calcErrorMessages: null,
        partnerId: null,
    },
    init() {

        this.$details = $('.page-type-details');
        this.params.objectGroupId = this.$details.attr('data-objectgroupid');

        if(! this.$details[0] && this.params.objectGroupId != 6) {
            return;
        }
        this.params.partnerId = $('[data-partnerid]').length ? $('[data-partnerid]').attr('data-partnerid') : null;
        this.labels = JSON.parse($('[data-labels]').attr('data-labels'));


        this.params.objectId = this.$details.attr('data-objectid');

        this.getParams();
        this.initDepartureCalendar();
        this.setDefaultDeparture();
        this.setUnitRates();

        $('.departure').on('click', e => {
            $('.departure').removeClass('active');

            const $target = $(e.currentTarget);
            $target.addClass('active');
            this.params.dateFrom = $target.attr('data-datefrom');
            $('[data-datefrom=' + this.params.dateFrom + ']').addClass('active');
            this.params.dateTo = $target.attr('data-dateto');

            this.printDates();

            functions.setUrlData({'dateFrom': this.params.dateFrom }, true);

        });

        $('[name=guests]').on('change', e => {
            e.preventDefault();
            const $target = $(e.currentTarget);
            this.params.unitId = $target.attr('data-unitid');
            this.params.guests = $target.val();

            if (this.params.guests && this.params.guests != '0,0') this.getCalculation();
        });

        $('[name=numberOfBeds], [name=category]').on('change', e => {
            detailsTravel.filter();
        });

        $('[name=sortBy]').on('change', e => {
            e.preventDefault();
            let sortBy = $(e.currentTarget).val();

            if (sortBy == 'priceAsc' || sortBy == 'priceDesc') {
                $('.unit[data-unitid]:not(.no-price)').each((index, unit) => {
                    const $unit = $(unit);
                    let total = $(unit).find('.unit-price-total').text();
                    total = total ? +(total.replace(/\D/g,'').replace(',', '.')) : (sortBy == 'priceAsc' ? 10000 : 0);
                    $unit.attr('style', 'order:' + (sortBy == 'priceAsc' ? total : (10000 - total)));
                });
            } else {
                $('.unit[data-unitid]:not(.no-price)').each((index, unit) => {
                    $(unit).attr('style', '');
                });
            }
        });


        $('.btn-booking').on('click', e => {

            const $target = $(e.currentTarget);
            if ( ! $target.attr('href')) {
                e.preventDefault();
                setTimeout(() => {
                    $target.closest('.unit').find('.input-guests').first().trigger('click');
                });
            }
        });

        //this.getCalculation();

        $(window).on('hashchange', e => {
            this.getParams();
            this.setUnitRates();

            $('.unit').each((index, unit) => {
                const $unit = $(unit);
                this.params.unitId = $unit.attr('data-unitid');
                this.params.guests = $unit.find('[name=guests]').val();

                if (this.params.guests && this.params.guests != '0,0') this.getCalculation();
            });
        });

    },
    filter() {
        let category = $('[name=category]').val() == '' ? 0 : $('[name=category]').val();
        let beds = $('[name=numberOfBeds]').val() == '' ? 0 : $('[name=numberOfBeds]').val();

        let found = 0;

        $('.unit-not-found').addClass('d-none');

        $('.unit[data-unitid]:not(.no-price)').each((index, unit) => {
            const $unit = $(unit);
            let hide = false;

            if (category && !beds) {
                hide = $unit.attr('data-category') != category;
            }
            else if (!category && beds) {
                hide = $unit.attr('data-beds') != beds;
            }
            else if (category && beds) {
                hide = $unit.attr('data-category') != category || $unit.attr('data-beds') != beds;
            }

            $unit.toggleClass('d-none', hide);
            found += !hide ? 1 : 0;
        });

        if ( ! found) {
            $('.unit-not-found').removeClass('d-none');
        }
    },
    setUnitRates() {
        if(this.params.dateFrom) {
            this.loader();

            const $units = $('.unit[data-unitid]');

            $units.find('.unit-price-old').text('');
            $units.find('.unit-price-total').text('');
            $units.find('.unit-price-total-label').addClass('d-none');
            $units.find('.unit-price-total').addClass('d-none');
            $units.find('.unit-price-old').addClass('d-none');

            setTimeout(() => {

                const $departure = $('.departure[data-datefrom=' + this.params.dateFrom + ']');
                const rates = JSON.parse($departure.attr('data-rates'));
                const maxPersons = JSON.parse($departure.attr('data-maxpersonsunits'));

                let excludedUnits = [];

                $('.unit').each((index, elem) => {
                    const unitIds = Object.keys(rates);
                    const unitId = $(elem).attr('data-unitid');

                    ! unitIds.includes(unitId) && excludedUnits.push(unitId);
                });

                if(excludedUnits.length) {
                    excludedUnits.forEach(unitId => {
                        const $unit = $('.unit[data-unitid="' + unitId + '"]');
                        $unit.find('.unit-price').addClass('d-none');
                    });
                }

                $('.unit[data-unitid]').addClass('d-none').addClass('no-price');

                Object.entries(rates).forEach(item => {
                    const unitId = item[0];
                    const rate = item[1];

                    const $unit = $('.unit[data-unitid="' + unitId + '"]');
                    let guests = $unit.find('[name=guests]').val();

                    if ( ! guests || guests == '0,0') {

                        if(maxPersons[unitId]) {    
                            $unit.find('.unit-price').removeClass('d-none');
                            $unit.find('.unit-price-total').removeClass('d-none');
    
                            $unit.find('.unit-price-old').toggleClass('d-none', ! rate.priceWithDiscount);
                            $unit.find('.unit-price-old').text(rate.priceWithDiscount ? rate.price : '');
                            $unit.find('.unit-price-total').text(rate.priceWithDiscount ? rate.priceWithDiscount : rate.price);
    
                            $unit.find('.fm-discount').toggleClass('d-none', ! rate.discountTitle);
                            $unit.find('.fm-discount-title').text(rate.discountTitle ? rate.discountTitle : '');
                            $unit.find('.fm-discount-valid-until').toggleClass('d-none', ! rate.validUntil);
                            $unit.find('.fm-discount-valid-until-date').text(rate.validUntil ? rate.validUntil : '');
    
                            $unit.find('.unit-price-total').toggleClass('text-danger', rate.priceWithDiscount ? true : false);
                            
                            $unit.find('.btn-booking').removeClass('d-none');
                            $unit.find('.btn-soldOut').addClass('d-none');
                            //$unit.removeClass('order-1');
                        } else {
                            //console.log(unitId + ': ' + maxPersons[unitId]);
                            $unit.find('.btn-booking').addClass('d-none');
                            $unit.find('.btn-soldOut').removeClass('d-none');
                            //$unit.addClass('order-1');
                        }

                    }
                    else {
                        if ($unit.find('.unit-price-old').text()) $unit.find('.unit-price-old').removeClass('d-none');
                        $unit.find('.unit-price-total-label').removeClass('d-none');
                        $unit.find('.unit-price-total').removeClass('d-none');
                    }

                    $unit.removeClass('d-none').removeClass('no-price');

                });

                $('[name=numberOfBeds]').change();
                $('[name=sortBy]').change();

            }, 1000);
        }
    },
    loader($target = null) {
        if ($target) {
            $target.addClass('active');
        } else {
            $('.unit-spinner-block').removeClass('d-none');
            $('.unit-spinner').addClass('active');
        }

        setTimeout(() => {
            if ($target) {
                $target.removeClass('active');
            } else {
                $('.unit-spinner-block').addClass('d-none');
                $('.unit-spinner').removeClass('active');
            }
        }, 800);
    },
    initDepartureCalendar() {
        const $bookingCalendar = $('#booking-calendar-slider');

        if($bookingCalendar[0]) {
            const length = $bookingCalendar.find('.keen-slider__slide').length;
            const perView = 6;
            
            let slidesPerView = length < perView ? length : perView;

            if(length < perView) {
                $('.booking-calendar-wrapper').addClass('col-xl-' + (slidesPerView + 2));
                $('.booking-calendar-wrapper').addClass('mx-auto');
            }
    
            this.slider = new Slider($bookingCalendar, {
                // mode: 'snap',
                //centered: true,
                duration: 200,
                fade: false,
                loop: false,
                controls: false,
                initial: 0,
                arrows: functions.isMobile() || length > slidesPerView,
                slides: {
                    perView: slidesPerView,
                    spacing: 0,
                },
                breakpoints: {
                    '(min-width: 577px) and (max-width: 1024px)': {
                        controls: true,
                        arrows: length > 6,
                        //centered: true,
                        slides: {
                            perView: 6.2,
                        },
                    },
                    '(max-width: 576px)': {
                        controls: true,
                        arrows: length > 2,
                        //centered: true,
                        slides: {
                            perView: 2.5,
                        },
                    },
                },
            });
        }
    },
    setDefaultDeparture() {

        let $date = $('[data-isavailable="1"]:first');
        let $dateSelected = $('[data-datefrom=' + this.params.dateFrom + ']');
        this.params.dateFrom = ! this.params.dateFrom ? $date.attr('data-datefrom') : ( ! $dateSelected.attr('data-isavailable') ? $date.attr('data-datefrom') : this.params.dateFrom);

        if ($('[data-datefrom=' + this.params.dateFrom + ']').length) {
            $('[data-datefrom=' + this.params.dateFrom + ']').addClass('active');
            this.params.dateTo = $('[data-datefrom=' + this.params.dateFrom + ']').attr('data-dateto');
        } else {

            $date.addClass('active');
            this.params.dateFrom = $date.attr('data-datefrom');
            this.params.dateTo = $date.attr('data-dateto');
        }

        this.params.guests = $('[name=guests]').val();

        functions.setUrlData({'dateFrom': this.params.dateFrom }, true);

        this.printDates();
    },
    printDates() {
        if (this.params.dateFrom && this.params.dateTo)
        {
            $('.date-from').text(functions.formatDate(this.params.dateFrom));
            $('.date-to').text(functions.formatDate(this.params.dateTo));
            $('.date-from').closest('.h6').removeClass('d-none');
        }
    },
    getParams() {
        this.params = details.getParams(this.params);
    },
    getCalculation() {

        details.getCalculation(this.params)
            .done(response => {
                this.calculationDone(response);
            }).fail(error => {

        });
    },
    calculationDone(response) {
        if(response.status) {
            const data = response.data || [];

            Object.entries(data).forEach(unit => {
                const unitId = unit[0];
                const unitData = unit[1];
                const $unit = $('.unit[data-unitid=' + unitId + ']');

                if(details.isBookable(unitData)) {
                    const unitCalc = unitData.calc;
                    const calcItems = unitCalc.items;
                    const total = unitCalc.total;
                    const currencySymbol = unitCalc.currencySymbol;

                    let priceOld = details.getCalcTotalOld(calcItems);

                    if(+priceOld.toFixed(2) > +total.toFixed(2)) {
                        $unit.find('.unit-price-old').removeClass('d-none');
                        $unit.find('.unit-price-old').text(functions.formatMoney(priceOld, 0, '.', ',') + ' ' + currencySymbol);
                        $unit.find('.unit-price-total').addClass('text-danger');
                    } else {
                        $unit.find('.unit-price-old').html('');
                        $unit.find('.unit-price-old').addClass('d-none');
                        $unit.find('.unit-price-total').removeClass('text-danger');
                    }
                    //console.log(total);

                    $unit.find('.btn-booking').removeClass('d-none');
                    $unit.find('.btn-soldOut').addClass('d-none');
                    $unit.find('.unit-price-total-label').removeClass('d-none');
                    $unit.find('.unit-price-total').removeClass('d-none');
                    $unit.find('.unit-price-total').text(functions.formatMoney(total, 0, '.', ',') + ' ' + currencySymbol);

                    $unit.find('.btn-booking').attr('href', $unit.find('.btn-booking').attr('data-href'));
                    $unit.find('.btn-booking').text(unitData.booking.status == 'Reservation' ? this.labels.book : this.labels.request );

                    if($unit.find('.btn-booking').attr('href')) {
                        $unit.find('.btn-booking').attr('href',
                            $unit.find('.btn-booking').attr('href').split('?')[0] +
                            '?unitId=' + unitId +
                            '&dateFrom=' + this.params.dateFrom +
                            '&dateTo=' + this.params.dateTo +
                            '&guests=' + $unit.find('[name=guests]').val() +
                            '&addAllOptionals=' + 1 +
                            (this.params.partnerId ? '&partnerId=' + this.params.partnerId : '')
                        );
                    }

                    this.printDates();

                    if ($unit.find('.unit-spinner.active').length) {
                        $unit.find('.unit-price-total-label').addClass('d-none');
                        $unit.find('.unit-price-total').addClass('d-none');
                        $unit.find('.unit-price-old').addClass('d-none');
                    }

                    //$unit.removeClass('order-1');
                    
                } else {
                    $unit.find('.btn-booking').attr('href', '');
                    $unit.find('.btn-booking').addClass('d-none');
                    $unit.find('.unit-price-total-label').addClass('d-none');
                    $unit.find('.unit-price-total').addClass('d-none');
                    $unit.find('.btn-soldOut').removeClass('d-none');
                    $unit.find('.btn-booking').text(this.labels.book);

                    //$unit.addClass('order-1');
                }
            });
        }
    }
};
